import type React from 'react';
import { FormField, Label, Textarea } from '@zillow/constellation-10';

import type { Section } from '../../../models/index';
import { ASBESTOS } from '../../../constants';
import YesAndNoExpansion from '../../Widgets/YesAndNoExpansion';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function Asbestos({ section, setSectionValues }: Props) {
  function onAsbestosOnPropertyYesClick(): void {
    setSectionValues({
      [ASBESTOS.FIELD_NAME.HAS_ON_PROPERTY]: true,
    });
  }

  function onAsbestosOnPropertyNoClick(): void {
    setSectionValues({
      [ASBESTOS.FIELD_NAME.HAS_ON_PROPERTY]: false,
    });
  }

  function onDescriptionChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({
      [ASBESTOS.FIELD_NAME.DESCRIPTION]: value,
    });
  }

  const asbestosOnProperty = section.getFieldValue(ASBESTOS.FIELD_NAME.HAS_ON_PROPERTY);

  return (
    <FormField
      required
      label={<Label>Do you know of any areas with asbestos on your property?</Label>}
      disabled={section.isFieldDisabled(ASBESTOS.FIELD_NAME.HAS_ON_PROPERTY)}
      control={
        <YesAndNoExpansion
          yesHandler={onAsbestosOnPropertyYesClick}
          noHandler={onAsbestosOnPropertyNoClick}
          yesActive={asbestosOnProperty}
          disabled={section.isFieldDisabled(ASBESTOS.FIELD_NAME.HAS_ON_PROPERTY)}
        >
          <FormField
            required
            label={<Label>Describe where on the property</Label>}
            control={
              <Textarea
                onChange={onDescriptionChange}
                value={section.getFieldValue(ASBESTOS.FIELD_NAME.DESCRIPTION)}
                css={{ resize: 'vertical' }}
                disabled={section.isFieldDisabled(ASBESTOS.FIELD_NAME.DESCRIPTION)}
              />
            }
          />
        </YesAndNoExpansion>
      }
    />
  );
}
